import { useTheme } from '@mui/material';
import {
  Art,
  BADGE_CLASS,
  INBOX_CLEAR_ILLUSTRATION_TEST_ID,
  InboxClearIllustrationSize,
  SPARK_CLASS,
} from './inbox-clear-illustration.styles';

// the composition is symmetric about x=100, so the tray sits exactly centred over
// whatever copy follows it at either size
export const InboxClearIllustration = ({
  size = 'page',
}: {
  size?: InboxClearIllustrationSize;
}) => {
  const { sys, extended } = useTheme().palette.custom.OV;

  return (
    <Art
      viewBox="0 0 200 170"
      size={size}
      aria-hidden="true"
      data-testid={INBOX_CLEAR_ILLUSTRATION_TEST_ID}
      data-size={size}
    >
      <ellipse cx="100" cy="156" rx="54" ry="6" fill={sys.surfaceContainerHighest} />
      <path
        d="M40 116 L57 86 h86 l17 30 v26 a8 8 0 0 1 -8 8 h-104 a8 8 0 0 1 -8 -8 Z"
        fill={sys.surfaceContainerHigh}
        stroke={sys.outline}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M40 116 h31 l8 11 h42 l8 -11 h31"
        fill="none"
        stroke={sys.outline}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <g className={BADGE_CLASS}>
        <circle cx="100" cy="55" r="21" fill={sys.secondaryContainer} />
        <path
          d="M90.5 55.5 l6.5 6.5 L110 47"
          fill="none"
          stroke={sys.onSecondaryContainer}
          strokeWidth="4.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        className={SPARK_CLASS}
        d="M46 30 l3.2 7.8 7.8 3.2 -7.8 3.2 -3.2 7.8 -3.2 -7.8 -7.8 -3.2 7.8 -3.2 Z"
        fill={sys.primary}
      />
      <path
        className={SPARK_CLASS}
        data-delay="2"
        d="M154 24 l2.6 6.3 6.3 2.6 -6.3 2.6 -2.6 6.3 -2.6 -6.3 -6.3 -2.6 6.3 -2.6 Z"
        fill={extended.Signature.color}
      />
      <path
        className={SPARK_CLASS}
        data-delay="3"
        d="M162 70 l2 4.8 4.8 2 -4.8 2 -2 4.8 -2 -4.8 -4.8 -2 4.8 -2 Z"
        fill={sys.secondary}
      />
      <path
        className={SPARK_CLASS}
        data-delay="4"
        d="M36 72 l1.8 4.4 4.4 1.8 -4.4 1.8 -1.8 4.4 -1.8 -4.4 -4.4 -1.8 4.4 -1.8 Z"
        fill={sys.secondary}
      />
      <circle
        className={SPARK_CLASS}
        data-delay="2"
        cx="66"
        cy="14"
        r="2.6"
        fill={extended.Signature.color}
      />
      <circle
        className={SPARK_CLASS}
        data-delay="3"
        cx="136"
        cy="10"
        r="2.6"
        fill={sys.primary}
      />
    </Art>
  );
};
